"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryTypeIterable = void 0;
exports.QueryTypeIterable = [
    'principalBalanceDailyAverage',
    'principalBalancePointInTime',
    'tAccountsSum',
    'orgProvidedInput',
];
//# sourceMappingURL=PostgresQuery.js.map